export const isDevelopment = () => {
    return process.env.REACT_APP_ADMIN_APP_IS_DEBUG === 'true';
};

export const isProduction = () => {
    return !isDevelopment();
}

export const getApiBaseUrl = () => {
    return process.env.REACT_APP_API_BASE_URL;
};

export const getFileBaseUrl = () => {
    return process.env.REACT_APP_FILE_BASE_URL;
};


export const getOurSupportEmail = () => {
    return process.env.REACT_APP_OUR_SUPPORT_EMAIL;
};

export const pageSizeOptions = [25, 50, 100];